import { PropertyType } from '../../../common';
import { propertiesFormatter } from '../../../common/services/propertiesFormatter';
import { columnFormatter } from '../../../view/pages/PlayerTransactions/PlayerTransaction.const';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	const mappedData = data.data.map((session: PropertyType) => {
		const newSessionData = propertiesFormatter(session, columnFormatter);
		return newSessionData;
	});
	return {
		transactions: mappedData,
		pagesTotal: data.pagination.total,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
